// extracted by mini-css-extract-plugin
export default {"base":"vp_fO1E8","text-reveal":"vp_XU76W"};